/* Connector marks for Curation's activation pages (FEATURES.curationSkin): the brand library's square for each MAP
   connector type, in place of MAP's own mixed set of icons; MAP's icon stays when the skin is off. */
import { SQUARES, CHANNEL_BRAND } from "./channelSquares";
import { FEATURES } from "./features";

export const chMark = (type: string, fallback: string): string =>
  (FEATURES.curationSkin && SQUARES[CHANNEL_BRAND[(type || "").toLowerCase()]]) || fallback;
